export default __webpack_public_path__ + "static/media/Countdown_3.813631d9.png";